import { Action } from '@reduxjs/toolkit';
import { Epic, combineEpics } from 'redux-observable';
import { filter, from, map, switchMap } from 'rxjs';

import { catchAndLogError } from 'utils/common';

import cartProducts from 'domains/cart_products';

import module from './index';
import * as api from './cart_billing.api';

import type { CheckoutRootState } from 'store/checkout_store';

const { actions, selectors } = module;

/**
 * Get cart billing details
 */
const getCartBillingEpic: Epic<Action, Action, CheckoutRootState> = (action$) =>
  action$.pipe(
    filter(actions.get.pending.match),
    switchMap(() =>
      from(api.get()).pipe(map(actions.get.fulfilled), catchAndLogError(actions.get.rejected()))
    )
  );

const refreshCartBillingEpic: Epic<Action, Action, CheckoutRootState> = (action$) =>
  action$.pipe(
    filter(
      (action) =>
        cartProducts.actions.updateQuantity.fulfilled.match(action) ||
        cartProducts.actions.destroy.fulfilled.match(action)
    ),
    map(() => actions.get.pending())
  );

const combined = combineEpics(getCartBillingEpic, refreshCartBillingEpic);
export default combined;
